import { createSelector } from 'reselect';

import { DataState } from '@/App/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectDisplayRuleStateMap } from '@/features/displayRules/selectDisplayRuleStateMap';
import ExpEngine from '@/services/ExpEngine';

export const selectDisplayRulesDataState = (screen: ScreenRef, action: ActionRef) =>
  createSelector([selectDisplayRuleStateMap], (displayRuleStateMap) => {
    const key = ExpEngine.getDisplayRuleService().getDisplayRuleKey(screen, action);
    const displayRuleState = displayRuleStateMap[key];
    return displayRuleState ? displayRuleState.dataState : DataState.INITIAL;
  });
